import React, { useState } from 'react';
import { Form, Modal } from 'antd';

const DeleteEntities = (props) => {
    const [inProgress, toggleInProgress] = useState(false);
    const form = Form.useForm();
    return (
        <Modal
            visible={true}
            title={`Are you sure you want to delete the selected ${props.entityNamePlural || 'Entities'}?`}
            okText="Delete"
            okButtonProps={{ disabled: inProgress }}
            cancelText="Cancel"
            onCancel={props.onCancel}
            onOk={async () => {
                try {
                    const r = await props.deleteEntities(props.Entities);
                    return r.success ? props.onSuccess(r) : props.onFailure(rr)
                } catch (e) {
                    return props.onFailure(getInnerError(e));
                }
            }}
        >
            This will permanently delete them from the database.
        </Modal>
    );
};

export default DeleteEntities;